import { minutesSinceMidnight } from "@/lib/clock";

/**
 * A usable work duration: a valid "HH:MM" that is not zero.
 *
 * Zero is rejected outright rather than treated as a short day — a day with
 * no work in it is said with "Ikke jobbet", which is deliberate where a
 * committed 00:00 would be an accident (CONTEXT.md: "Ikke jobbet"). The
 * field's own parser reaches 00:00 on the way to almost every other value,
 * so rejecting it here is what keeps a single keystroke from recording a
 * zero-length workday.
 */
export function isWorkDuration(value: unknown): value is string {
  const minutes = minutesSinceMidnight(value);
  return minutes !== null && minutes > 0;
}
